import { render, staticRenderFns } from "./SelectedAmbulance.vue?vue&type=template&id=2e273711&scoped=true&"
var script = {}
import style0 from "./SelectedAmbulance.vue?vue&type=style&index=0&id=2e273711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e273711",
  null
  
)

export default component.exports